import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { deleteGoalIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, number>({
		mutationFn: processResponse((id: number) => deleteGoalIdV2(id)),
		onSuccess: (_data, id) => {
			queryClient.removeQueries({ queryKey: GoalsKeys.detail(id) });
			queryClient.invalidateQueries({ queryKey: GoalsKeys.all });
		},
	});
};
